import { CSSProperties, useCallback, useEffect, useState } from 'react';
import { Grid, GridRow } from '../../models';
import { apiClient, apiErrorMessage } from '../../utils';
import moment from 'moment';
import { Typography } from 'antd';

export function RecordRevisionsHistoryTable(props: { grid?: Grid; gridRow?: GridRow; onRowAdded: () => void }) {
  const [rows, setRows] = useState<GridRow[]>();
  const [revisionFieldId, setRevisionFieldId] = useState<string>();
  const [modifiedFieldIds, setModifiedFieldIds] = useState<string[]>();

  const { Text } = Typography;

  useEffect(() => {
    const revisionField = props.grid?.fields.find(f => f.isRevision);
    setRevisionFieldId(revisionField?.id);
  }, [props.grid]);

  const loadRecords = useCallback(() => {
    const body = {
        gridId: props.grid?.id,
        revisionsFor: [props.gridRow?.latestRevisionRecordId],
        limit: 0,
    }

    apiClient
      .post(`records/records`, body)
      .then((response: any) => {
        setRows(response.data.records);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      });
  }, [props.grid?.id, props.gridRow?.latestRevisionRecordId]);

  useEffect(() => {
    loadRecords();
  }, [loadRecords]);

  useEffect(() => {
    if (!props.grid || !rows?.length) {
      return;
    }

    const newModifiedFieldIds: string[] = [];
    const fields = props.grid?.fields?.filter(f => !f.isIdentifier);
    for (const field of fields) {
      const values = rows.map(r => r.cells[field.id].value as string);
      for (let i = 0; i < values.length - 1; i++) {
        const value1 = values[i];
        const value2 = values[i + 1];
        if (field.dataType === 'SUBGRID') {
          if (JSON.stringify(value1) !== JSON.stringify(value2)) {
            newModifiedFieldIds.push(field.id);
            break;
          }
        } else {
          if (value1 !== value2) {
            newModifiedFieldIds.push(field.id);
            break;
          }
        }
      }
    }

    setModifiedFieldIds(newModifiedFieldIds);
  }, [props.grid, rows]);

  if (!revisionFieldId || !rows?.length) {
    return null;
  }

  const tdStyle: CSSProperties = {
    border: '1px solid #aaa',
    padding: '0.5rem',
    width: '10rem',
  };

  return (
    <>
      <div style={{ marginBottom: '1rem' }}>
        <Text type="secondary">X: Bir önceki revizyona göre değişikliğin hangi veri elemanında yapıldığını gösterir.</Text>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ border: '1px solid #aaa' }}>
          <tr>
            <th style={tdStyle}>Revizyonlar</th>
            {rows?.map(r => (
              <th style={{ ...tdStyle, textAlign: 'center', backgroundColor: props.gridRow?.id === r.id ? '#ffe58f' : undefined }}>
                {r.cells[revisionFieldId].value}
              </th>
            ))}
          </tr>
          <tr>
            <th style={tdStyle}>Tarih</th>
            {rows?.map(r => (
              <td style={{ ...tdStyle, backgroundColor: props.gridRow?.id === r.id ? '#ffe58f' : undefined }}>
                {moment(r.updatedAt).format('DD.MM.yyyy')}
                <br />
                {moment(r.updatedAt).format('HH:mm:ss')}
              </td>
            ))}
          </tr>
          <tr>
            <th style={tdStyle}>Açıklama</th>
            {rows?.map(r => (
              <td style={{ ...tdStyle, backgroundColor: props.gridRow?.id === r.id ? '#ffe58f' : undefined }}>{r.revisionComment}</td>
            ))}
          </tr>
          <tr>
            <th style={tdStyle}>Kullanıcı</th>
            {rows?.map(r => (
              <td style={{ ...tdStyle, backgroundColor: props.gridRow?.id === r.id ? '#ffe58f' : undefined }}>
                {r.revisionCommentBy?.fullName || r.createdBy?.fullName}
              </td>
            ))}
          </tr>
          {modifiedFieldIds?.map(mf => (
            <tr>
              <th style={tdStyle}>{props.grid?.fields.find(f => f.id === mf)?.name}</th>
              {rows?.map((r, i) => (
                <td style={{ ...tdStyle, textAlign: 'center', backgroundColor: props.gridRow?.id === r.id ? '#ffe58f' : undefined }}>
                  {i + 1 < rows.length &&
                  (props.grid?.fields.find(f => f.id === mf)?.dataType === 'SUBGRID'
                    ? JSON.stringify(r.cells[mf].value) !== JSON.stringify(rows[i + 1].cells[mf].value)
                    : r.cells[mf].value !== rows[i + 1].cells[mf].value)
                    ? 'X'
                    : null}
                </td>
              ))}
            </tr>
          ))}
        </table>
      </div>
    </>
  );
}
